import gql from 'graphql-tag';

import { executeGqlMutation } from 'src/graphql/client';
import { getSingleProp, unwrapEdges } from 'src/lib/graphql';
import type {
  BackendCustomerPersona,
  BackendCustomerPersonaConnection,
  BackendMutationExtractCustomerPersonaArgs,
} from 'src/types/backend';

import { CUSTOMER_PERSONA_FRAGMENT } from './schema';

const MUTATION = gql`
  mutation ExtractCustomerPersona(
    $brandVoiceId: ID!
    $urls: [String!]
    $text: String
    $resourceId: ID
    $count: Int
  ) {
    extractCustomerPersona(
      brandVoiceId: $brandVoiceId
      urls: $urls
      text: $text
      resourceId: $resourceId
      count: $count
    ) {
      edges {
        node {
          ...CustomerPersona
        }
      }
    }
  }
  ${CUSTOMER_PERSONA_FRAGMENT}
`;

type Variables = BackendMutationExtractCustomerPersonaArgs;
type Result = BackendCustomerPersonaConnection;

export const extractCustomerPersona = async (variables: Variables) => {
  const response = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      traceAcRequests: true,
    },
  });
  const result = getSingleProp<Result>(response.data);
  return unwrapEdges<BackendCustomerPersona>(
    result?.edges as Array<{ node: BackendCustomerPersona }> | undefined
  );
};
